import { css } from "styled-components";

export class Property {
  constructor(number, unit) {
    this.number = number;
    this.unit = unit;
  }
  get css() {
    return `${this.number}${this.unit}`;
  }
  inPixel(parentElement = document.documentElement) {
    switch (this.unit) {
      default:
      case "px":
        return this.number;
      case "em":
        return (
          this.number * parseFloat(getComputedStyle(parentElement).fontSize)
        );
      case "rem":
        return (
          this.number *
          parseFloat(getComputedStyle(document.documentElement).fontSize)
        );
      case "vw":
        return (this.number * window.innerWidth) / 100;
      case "vh":
        return (this.number * window.innerHeight) / 100;
    }
  }
}

export const breakpointLabels = ["xs", "sm", "md", "lg", "xl"];
export const breakpoints = [600, 900, 1200, 1800];

export class ResponsiveStruct {
  constructor(unit, ...values) {
    this.values = values;
    this.unit = unit;
  }
  css(property, unit = this.unit) {
    return css`
			${property}: ${this.values[4]}${unit};
			@media screen and (max-width: ${breakpoints[0]}px) {
				${property}: ${this.values[0]}${unit};
			}
			@media screen
				and (min-width: ${breakpoints[0]}px)
				and (max-width: ${breakpoints[1]}px)
			{
				${property}: ${this.values[1]}${unit};
			}
			@media screen
				and (min-width: ${breakpoints[1]}px)
				and (max-width: ${breakpoints[2]}px)
			{
				${property}: ${this.values[2]}${unit};
			}
			@media screen
				and (min-width: ${breakpoints[2]}px)
				and (max-width: ${breakpoints[3]}px)
			{
				${property}: ${this.values[3]}${unit};
			}
		`;
  }
}

export const containerWidths = breakpoints.map(v => v * 0.955);
containerWidths[3] = 1440;
export const gutterWidth = 30;

export const media = breakpoints.reduce((acc, value, index) => {
  // prettier-ignore
  acc[breakpointLabels[index]] = (...args) => css`@media (max-width: ${value}px) {${css(...args)};}`;
  return acc;
}, {});

export const typography = {
  size: new ResponsiveStruct("px", 15, 15, 15, 15, 15),
};

export const color = {
  battleship_grey: "#676f78",
  black: "#000000",
  bluegreen: "#007284",
  charcoal: "#3c3c3b",
  ice_blue: "#edfaff",
  light_blue_grey: "#def3ee",
  light_grey_60: "rgba(196, 204, 191, 0.6)",
  light_grey: "#c4ccbf",
  light_peach: "#ffddce",
  light_turquoise: "#33BFBB",
  light_blue_grey_two: "#bdd9e0",
  lighter_turquoise: "#00D3D1",
  navy: "#001837",
  pale_blue: "#e4f1fd",
  teal_blue: "#018eaa",
  tealish_two: "#1cbdb8",
  turquoise: "#00afaa",
  very_light_pink: "#fff5ec",
  very_light_pink_two: "#fdf4ef",
  white: "#ffffff",
  white_two: "#d8d8d8",
  white_3: "#f6f6f6",
  white_four: "#f8f8f8",
  white_five: "#fbfbfb",
};

export const zindex = [
  "navigation",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
].reduce((acc, key, index, arr) => {
  // This transforms the array above into an object
  // an object of z-index values with array element as keys
  const max = arr.length;
  acc[key] = max - index;
  return acc;
}, {});



// WEBPACK FOOTER //
// ./src/style/Variables.js